import { ASTWithName } from '@angular/compiler';
import { Injectable } from '@angular/core';
// import { throwMatDialogContentAlreadyAttachedError } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { CognitoUser, CognitoUserPool, CognitoUserSession } from 'amazon-cognito-identity-js';
import { BehaviorSubject, Observable, Subject, observable, of } from 'rxjs';
import { delay, timeInterval } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { callbackify } from 'util';
import { signIn, confirmSignIn, signOut, getCurrentUser, fetchAuthSession, resetPassword,
         fetchUserAttributes, confirmResetPassword, updatePassword } from 'aws-amplify/auth';

@Injectable({
  providedIn: 'root'
})
export class AuthNewService {
  user = new Subject<CognitoUser>();
  currentUsername: string;
  currentEmail: string;
  currentUser!: CognitoUser;
  passwordChanged = new BehaviorSubject<boolean>(false);
  forgotPasswordCode = new BehaviorSubject<boolean>(false);
  forgotPasswordMessage = new BehaviorSubject<string>('');
  userGroup = new BehaviorSubject('');
  groups;
  forgotMessage;
  signinError = new BehaviorSubject<string>('');
  getCurrentLoginUser = new Subject<CognitoUser>();
  private userPool = new CognitoUserPool(environment.userPool);

  constructor(private router: Router) {
    
  }


  // function to signin
  async handleSignIn(username: string, password: string) {
    try {
      const { isSignedIn, nextStep } = await signIn({username, password});
      if (
        nextStep.signInStep === "CONFIRM_SIGN_IN_WITH_EMAIL_CODE" ||
        nextStep.signInStep === "CONFIRM_SIGN_IN_WITH_SMS_CODE" ||
        nextStep.signInStep === "CONFIRM_SIGN_IN_WITH_TOTP_CODE"
      ) {
        return {Status: "MFA"};
      } else if ( nextStep.signInStep === "RESET_PASSWORD" ) {
        return {Status: "NEW_PASSWORD"};
      } else if ( nextStep.signInStep === "CONFIRM_SIGN_IN_WITH_NEW_PASSWORD_REQUIRED") {
        return {Status: "NEW_PASSWORD"}
      } else {
        if ( isSignedIn ) {
          const userAttributes = await fetchUserAttributes();
          if (userAttributes) {
            const access = userAttributes['custom:access'];
            if (access) {
              sessionStorage.setItem('access', access);
            }
            this.setUserData();
          }
            return {Status: "SUCCESS"};
        } else {
//           console.log("Unhandled case from signin call:");
//           console.log(nextStep.signInStep);
          return {Status: "UNHANDLED"};
        }
      }
    } catch (error) {
      this.signinError.next(error);
      return {Status: "ERROR"};
    }
  }

  async handleConfirmCode(code:string) {
    try {
      const { isSignedIn, nextStep } = await confirmSignIn({challengeResponse: code});
      return { isSignedIn, nextStep };
    } catch (error) {
      return { isSignedIn:false, nextStep:"Error"};
    }
  }

  async getGroups() {
    try {
      const userAttributes = fetchUserAttributes();
      // console.log(userAttributes);
      this.userGroup.next(userAttributes['cognito:groups']);
    } catch (error) {
//       console.log(error);
    }
  }

  async newPassword(newPassword:string) {
    try {
      await confirmSignIn({challengeResponse:newPassword});
      this.passwordChanged.next(true);
    } catch(error) {
//       console.log(error);
    }
  }

  async forgetPassword(username:string) {
    try {
      const result = await resetPassword({username});
//       console.log(result);
      this.forgotPasswordCode.next(true);
    } catch(error) {
//       console.log(error);
    }
  }

  async forgetPasswordConfirm(username, code, password) {
    try {
      await confirmResetPassword({username: username, newPassword: password, confirmationCode: code});
      this.forgotMessage = 'Password Changed';
    } catch(error) {
//       console.log(error);
      this.forgotMessage = 'Error';
    }
    setTimeout(() => {
      this.forgotPasswordMessage.next(this.forgotMessage);
    }, 2000);

  }

  async getAuthenticatedUser() {
    const user = await getCurrentUser();
    return user;
  }

  async handleSignout() {
    await signOut();
    this.router.navigate(['']);
  }

  async getTokensWithCode(code) {
    const requestParams = new URLSearchParams({
      grant_type: "authorization_code",
      client_id: environment.userPool.ClientId,
      redirect_uri: environment.redirectUrl,
      code: code
    });

    try {
      const response = await fetch(environment.tokenEndpoint, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        },
        body: requestParams
      });

      if (!response.ok) {
        console.log("Token endpoint call failed");
      }

      const tokens = await response.json();

      return {
        accessToken: tokens.access_token,
        idToken: tokens.id_token,
        refreshToken: tokens.refresh_token,
        tokenType: tokens.token_type,
        expiresIn: tokens.expires_in
      };
    } catch (error) {
      console.log("Error when calling getTokensWithCode");
      return;
    }
  }

  setAmplifySession(tokens) {
    const payload = JSON.parse(atob(tokens.idToken.split('.')[1]));
    console.log(payload);
    const username = payload['cognito:username'] || payload.sub;
    console.log(username);

    const clientId = environment.userPool.ClientId;
    const keyPrefix = `CognitoIdentityServiceProvider.${clientId}`;

    localStorage.setItem(`${keyPrefix}.LastAuthUser`, username);
    localStorage.setItem(`${keyPrefix}.${username}.accessToken`, tokens.accessToken);
    localStorage.setItem(`${keyPrefix}.${username}.idToken`, tokens.idToken);
    localStorage.setItem(`${keyPrefix}.${username}.refreshToken`, tokens.refreshToken);

  }

  async setUserData() {
    const userAttributes = await fetchUserAttributes();
    this.currentEmail = userAttributes.email;
    this.currentUsername = this.currentEmail.split('@')[0];
  }

}
